<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysisPollutionCases',
  routeInfo: {
    label: '污染案例',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/11PollutionCases/index.vue